module.exports = __webpack_public_path__ + "assets/img/1.43cdb2a3.jpg";